export const ROOM_SERVICE_ALERT_EVENT = "room-service-alert";
const NEW_COUNT_KEY = "roomServiceNewCount";
const URGENT_COUNT_KEY = "roomServiceUrgentCount";
const SEEN_IDS_KEY = "roomServiceSeenRequestIds";

export const getRoomServiceNewCount = (): number => {
  const stored = sessionStorage.getItem(NEW_COUNT_KEY);
  if (stored == null) return 0;
  const parsed = Number(stored);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const getRoomServiceUrgentCount = (): number => {
  const stored = sessionStorage.getItem(URGENT_COUNT_KEY);
  if (stored == null) return 0;
  const parsed = Number(stored);
  return Number.isFinite(parsed) ? parsed : 0;
};

const readSeenIds = (): Set<number> => {
  try {
    const raw = sessionStorage.getItem(SEEN_IDS_KEY);
    return new Set(raw ? (JSON.parse(raw) as number[]) : []);
  } catch {
    return new Set();
  }
};

export const getSeenRoomServiceRequestIds = (): Set<number> => readSeenIds();

export const publishRoomServiceAlert = (
  newCount: number,
  urgentCount: number,
) => {
  sessionStorage.setItem(NEW_COUNT_KEY, String(newCount));
  sessionStorage.setItem(URGENT_COUNT_KEY, String(urgentCount));
  window.dispatchEvent(
    new CustomEvent(ROOM_SERVICE_ALERT_EVENT, {
      detail: { newCount, urgentCount },
    }),
  );
};

/** Marks requests as reviewed (opened the Room Service page, or acted on
 * the auto-popup) so they stop counting toward the sidebar badge and stop
 * re-triggering the new-request popup. Persisted in sessionStorage so it
 * survives SPA navigation for the rest of this browser session. */
export const markRoomServiceRequestsSeen = (requestIds: number[]) => {
  if (requestIds.length === 0) return;
  const seen = readSeenIds();
  requestIds.forEach((id) => seen.add(id));
  sessionStorage.setItem(SEEN_IDS_KEY, JSON.stringify(Array.from(seen)));
};

/** Called by the Room Service page once it has the current request list —
 * every still-New request it just showed the admin is, by definition, no
 * longer "new", so the badge should drop to whatever arrives after this
 * point. */
export const acknowledgeRoomServiceRequests = (requestIds: number[]) => {
  markRoomServiceRequestsSeen(requestIds);
  publishRoomServiceAlert(0, 0);
};
